function importAll(r) {
    return r.keys().map(r);
  }
  
  const India_H = importAll(require.context('../assets/photos/India_H', false, /\.(png|jpe?g|svg)$/));
    
  export default India_H;